import { Injectable } from '@angular/core';
import * as CryptoJS from 'crypto-js';

@Injectable({
  providedIn: 'root'
})

export class EncrDecrService {
  constructor() { }
 
  //The set method is use for encrypt the value.
  set(keys, value){ 
    var key = CryptoJS.enc.Utf8.parse('0123456789123456');
    var iv = CryptoJS.enc.Utf8.parse('0123456789123456');
    var encrypted = CryptoJS.AES.encrypt(CryptoJS.enc.Utf8.parse(value.toString()), key,
    {
        keySize: 128 / 8,
        iv: iv,
        mode: CryptoJS.mode.CBC,
        padding: CryptoJS.pad.Pkcs7
    });  
    var strArray = encrypted.toString().split("/");
        var new_encrypted='';
        // Display array values on page
        for(var i = 0; i < strArray.length; i++){
          new_encrypted+=strArray[i]; 
          if(i < strArray.length-1)  new_encrypted+='*****';
        }
    return new_encrypted;
  }

  //The get method is use for decrypt the value.
  get(keys, value){
    var new_value=''; 
    var strArray = value.split("*****"); 
    // Display array values on page
    for(var i = 0; i < strArray.length; i++){
      new_value+=strArray[i]; 
      if(i < strArray.length-1)  new_value+='/';
    } 
    var key = CryptoJS.enc.Utf8.parse('0123456789123456');
    var iv = CryptoJS.enc.Utf8.parse('0123456789123456');
    var decrypted = CryptoJS.AES.decrypt(new_value, key, {
        keySize: 128 / 8,
        iv: iv,
        mode: CryptoJS.mode.CBC,
        padding: CryptoJS.pad.Pkcs7
    });
 
    return decrypted.toString(CryptoJS.enc.Utf8);
  }
}